import { gql } from '@apollo/client'

export const orderCancelQuery = gql(`
  mutation orderCancel($input: JSON!) {
    orderCancel(input: $input) {
      _id
      status
    }
  }
`)
